import Logo from "../asset/image/Logos/logo-centrocard.png";
import LogoWhite from "../asset/image/Logos/logo-blanco.png";
import LogoLetras from "../asset/image/Logos/logoletras.png";
import userImageDefault from "../asset/image/Users/defaultUser.jpg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressCard, faPlane, faArchive, faCalendarCheck, faFolderOpen } from '@fortawesome/free-solid-svg-icons';

//import Aimogasta from "../asset/image/Subsidiaries/sub_aimogasta.png"
import CasaCentral from "../asset/image/Subsidiaries/sub_casacentral.jpg"
import Andalgala from "../asset/image/Subsidiaries/sub_andalgala.png"
import Belen from "../asset/image/Subsidiaries/sub_belen.png"
import Chilecito from "../asset/image/Subsidiaries/sub_chilecito.png"
import LaRioja from "../asset/image/Subsidiaries/sub_rioja.jpg"
import Recreo from "../asset/image/Subsidiaries/sub_recreo.png"
import SantaMaria from "../asset/image/Subsidiaries/sub_santamaria.png"
import Tinogasta from "../asset/image/Subsidiaries/sub_tinogasta.png"
import ValleViejo from "../asset/image/Subsidiaries/sub_valleviejo.jpg"

// Licence Info:
import LlamarJefe from "../asset/image/RRHH/LicenceInfo/llamarjefe.jpg"
import IrMedico from "../asset/image/RRHH/LicenceInfo/irmedico.jpg"
import IrMedicoLaboral from "../asset/image/RRHH/LicenceInfo/irmedicolaboral.jpg"
import CertificadoMedico from "../asset/image/RRHH/LicenceInfo/certificadomedico.jpg"

// Banners Home:
import Banner1 from "../asset/image/Banners/1.jpg"
import Banner2 from "../asset/image/Banners/2.jpg"
import Banner3 from "../asset/image/Banners/3.jpg"
import Banner4 from "../asset/image/Banners/4.jpg"
import Banner5 from "../asset/image/Banners/5.jpg"
import Banner6 from "../asset/image/Banners/6.jpg"

// Caras:
import Happy from "../asset/image/Logos/felicidad.png"
import Wink from "../asset/image/Logos/exclamacion.png"

const getImages = () => ({
  logo: Logo,
  logoWhite: LogoWhite,
  logoLetras: LogoLetras,
  userImageDefault: userImageDefault,
  57: <FontAwesomeIcon icon={faAddressCard} />,
  58: <FontAwesomeIcon icon={faFolderOpen} />,
  59: <FontAwesomeIcon icon={faArchive} />,
  60: <FontAwesomeIcon icon={faCalendarCheck} />,
  61: <FontAwesomeIcon icon={faPlane} />,
  subsidiaries: {
    1: CasaCentral,
    3: Andalgala,
    4: Belen,
    5: Chilecito,
    6: LaRioja,
    7: Recreo,
    8: SantaMaria,
    9: Tinogasta,
    10: ValleViejo
  },
  licenceInfo: {
    LlamarJefe: LlamarJefe,
    IrMedico: IrMedico,
    IrMedicoLaboral: IrMedicoLaboral,
    CertificadoMedico: CertificadoMedico,
  },
  banners: {
    1: Banner1,
    2: Banner2,
    3: Banner3,
    4: Banner4,
    5: Banner5,
    6: Banner6
  },
  faces: {
    happy: Happy,
    wink: Wink
  }
});

export default getImages;